var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "border-color1 oldInfoBox" }, [
    _c("div", { staticClass: "headline" }, [_vm._v("Freunde einladen")]),
    _vm._v(" "),
    _c("div", [_vm._v("Kennst du jemanden der auch mitmachen möchte?")]),
    _vm._v(" "),
    _vm.error
      ? _c("div", { staticClass: "errorBox" }, [_vm._v(_vm._s(_vm.errorText))])
      : _vm._e(),
    _vm._v(" "),
    _vm.success
      ? _c("div", { staticClass: "errorText" }, [_vm._v("Einladung gesendet")])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticStyle: { margin: "5px 0 15px 0" } }, [
      _c(
        "p",
        { staticClass: "font075", staticStyle: { "margin-bottom": "0px" } },
        [_vm._v("E-Mail-Adresse")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.email,
            expression: "email"
          }
        ],
        attrs: { type: "text", name: "invitationEmail", id: "invitationEmail" },
        domProps: { value: _vm.email },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.email = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticStyle: { margin: "5px 0 15px 0" } }, [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.text,
            expression: "text"
          }
        ],
        attrs: {
          type: "text",
          name: "invitationText",
          id: "invitationText",
          placeholder: "Dein persönlicher Einladungstext",
          rows: "5"
        },
        domProps: { value: _vm.text },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.text = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass:
          "btn btn-blue btn-block btn-lg btn-lg-reset-font-size text-uppercase text-letter-spacing2 white-space-normal",
        attrs: { type: "button", disabled: _vm.isDisabled },
        on: { click: _vm.sendInvitation }
      },
      [_c("span", [_vm._v("Einladung senden")])]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3720affd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3720affd","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileInvitation.vue
// module id = 593
// module chunks = 2